export default {
    methods: {
        viewAuthentication() {
            this.$gtag.set({ 'screenName': 'CRM Login', 'page_title': 'CRM Login' })
            this.$gtag.screenview({ screen_name: 'CRM Login' })
            this.$gtag.event('view', {
              'event_category' : 'Authentication',
              'event_label' : 'firstAuthenticationPage'
            })
        },
        trackAuthentication(id) {
            let eventList = [null, null, 'selectCountryNumber', 'inputTelephoneNumber', 'clickLoginAgain', 'clickLogin',
                            'clickLoginLINE', 'clickNewRegister', 'clickRegister', 'inputName', 'inputEmail',
                            'inputGenderMale', 'inputGenderFemale', 'inputGenderNone', 'inputBirthday', 'giveConsentonCRM',
                            'viewTermandConditionCRM', 'viewTermandandConditionCRM', 'clickAcceptTermandConditionCRM', 'inputOTP', 'clickCancelErrorPhonNumner',
                            'clickKeepLoginErrorPhonNumner']
            let event = {
                event_category : 'Authentication',
                event_label: eventList[id]
            }
            this.$gtag.event('click', event)
        },
        viewAccount() {
            this.$gtag.set({ 'screenName': 'CRM Account', 'page_title': 'CRM Account' })
            this.$gtag.screenview({ screen_name: 'CRM Account' })
            this.$gtag.event('view', {
              'event_category' : 'ProfileCRM',
              'event_label' : 'tabAccountCRM'
            })
        },
        trackAccount(id, category, action = 'click') {
            let eventList = [null, null, 'clickTabAccount', 'clickEdtiProfileCRM', 'clickSaveEditProfileCRM', 'editCRMProfilePic',
                            'clickBackEdtiProfileCRM', 'clickConnnectAccount', 'clickToggleLINEOn', 'clickToggleLINEOff', 'clickCancelOffToggleLINE',
                            'clickConfirmOffToggleLINE', 'connectLINECompleted', 'changeLanguageEN', 'changeLanguageTH', 'clickLogout']
            let event = {
                event_category : category,
                event_label: eventList[id]
            }
            this.$gtag.event(action, event)
        },
        viewActivity(page, category, label) {
            this.$gtag.set({ 'screenName': page, 'page_title': page })
            this.$gtag.screenview({ screen_name: page })
            this.$gtag.event('view', {
              'event_category' : category,
              'event_label' : label
            })
        },
        trackActivity(id, category, action = 'click') {
            let eventList = [null, null, 'clickTabHomeCRM', 'selectBranchonCRM', 'selectCRMPromotion', 'viewCRMPromotionDetail',
                            'clickRedeemCRMPromotion', 'clickConfirmRedeemCRMPromotion', 'clickCancelRedeemCRMPromotion', 'viewRedeemCodeCRMPromotion', 'clickDoneCodeCRMPromotion',
                            'clickCheckPoint', 'viewMyPointHistory', 'clickAllActivityCRMPointHistory', 'clickEarnedCRMPointHistory', 'clickBurnedCRMPointHistory',
                            'clickBackCRMPointHistory']
            let event = {
                event_category : category,
                event_label: eventList[id]
            }
            this.$gtag.event(action, event)
        },
        viewReward() {
            this.$gtag.set({ 'screenName': 'CRM My Coupon', 'page_title': 'CRM My Coupon' })
            this.$gtag.screenview({ screen_name: 'CRM My Coupon' })
            this.$gtag.event('view', {
              'event_category' : 'CRMMyCoupon',
              'event_label' : 'tabMyRewardCRM'
            })
        },
        trackReward(id, category, action = 'click') {
            let eventList = [null, null, 'clickTabMyRewardCRM', 'viewCouponDetail', 'viewMyPointHistory']
            let event = {
                event_category : category,
                event_label: eventList[id]
            }
            this.$gtag.event(action, event)
        },
        viewFeedback() {
            this.$gtag.set({ 'screenName': 'CRM Feedback', 'page_title': 'CRM Feedback' })
            this.$gtag.screenview({ screen_name: 'CRM Feedback' })
            this.$gtag.event('view', {
              'event_category' : 'CRMFeedback',
              'event_label' : 'viewCustomerFeedbackFlow'
            })
        },
        trackFeedback(id, category, action = 'click') {
            let eventList = [null, 'clickOKEarnPoint', 'viewCustomerFeedbackFlow', 'selectStarRatingonFeedback', 'selectDefaultFeedback', 'clickCustomFeedback',
                            'clickSendFeedbackCRM', 'viewCompleteFeedback', 'clickCloseCompleteFeedback']
            let event = {
                event_category : category,
                event_label: eventList[id]
            }
            this.$gtag.event(action, event)
        },
    }
  }